import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconParagraph: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconParagraph"><Path fillRule="evenodd" clipRule="evenodd" d="M2.75 8C2.75 5.23858 4.98858 3 7.75 3H21V5H16V21H14V5H11V21H9V13H7.75C4.98858 13 2.75 10.7614 2.75 8ZM9 11V5H7.75C6.09315 5 4.75 6.34315 4.75 8C4.75 9.65685 6.09315 11 7.75 11H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconParagraph;
